(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    // Mobile nav toggle
    document.querySelectorAll('[data-dockd-menu-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var nav = document.querySelector(btn.getAttribute('data-dockd-menu-toggle'));
        if (nav) nav.classList.toggle('is-open');
      });
    });

    // FAQ accordions
    document.querySelectorAll('.dockd-faq-item__q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.dockd-faq-item');
        var wasOpen = item.classList.contains('is-open');
        item.parentElement.querySelectorAll('.dockd-faq-item.is-open').forEach(function (el) {
          if (el !== item) el.classList.remove('is-open');
        });
        item.classList.toggle('is-open', !wasOpen);
      });
    });

    // Bundle / tier picker -> updates hidden variant id input in the form
    document.querySelectorAll('[data-dockd-tiers]').forEach(function (wrap) {
      var form = wrap.closest('form');
      var variantInput = form ? form.querySelector('[name="id"]') : null;
      wrap.querySelectorAll('.dockd-tier').forEach(function (tier) {
        tier.addEventListener('click', function () {
          wrap.querySelectorAll('.dockd-tier').forEach(function (t) { t.classList.remove('is-selected'); });
          tier.classList.add('is-selected');
          if (variantInput) variantInput.value = tier.getAttribute('data-variant-id');
        });
      });
    });

    // Hero gallery thumbnails -> swap the main product image.
    // The main image can carry a responsive srcset; if we only changed .src the
    // browser would keep using the old srcset candidates and ignore the new src,
    // so clear srcset/sizes first to force the browser to actually use the new src.
    document.querySelectorAll('[data-dockd-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var gallery = thumb.closest('.dockd-hero__gallery');
        var mainImg = gallery ? gallery.querySelector('.dockd-hero__main-image') : null;
        var fullSrc = thumb.getAttribute('data-dockd-thumb-full');
        if (!mainImg || !fullSrc) return;
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');
        mainImg.src = fullSrc;
      });
    });

    // Quantity stepper
    document.querySelectorAll('[data-dockd-qty]').forEach(function (qty) {
      var input = qty.querySelector('input');
      qty.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = btn.getAttribute('data-step') === 'down' ? -1 : 1;
          var val = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = val;
        });
      });
    });

    // Reviews filter chips (visual/demo filtering by rating star count via data attribute)
    document.querySelectorAll('[data-dockd-review-filters]').forEach(function (wrap) {
      var grid = document.querySelector(wrap.getAttribute('data-dockd-review-filters'));
      if (!grid) return;
      wrap.querySelectorAll('.dockd-filter-chip').forEach(function (chip) {
        chip.addEventListener('click', function () {
          wrap.querySelectorAll('.dockd-filter-chip').forEach(function (c) { c.classList.remove('is-active'); });
          chip.classList.add('is-active');
          var filter = chip.getAttribute('data-filter');
          grid.querySelectorAll('.dockd-review-card').forEach(function (card) {
            if (filter === 'all') {
              card.hidden = false;
              return;
            }
            card.hidden = card.getAttribute('data-rating') !== filter;
          });
        });
      });
    });

    // Load more reviews
    document.querySelectorAll('[data-dockd-load-more]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var grid = document.querySelector(btn.getAttribute('data-dockd-load-more'));
        if (!grid) return;
        var hidden = grid.querySelectorAll('.dockd-review-card[data-extra="true"][hidden]');
        for (var i = 0; i < hidden.length && i < 6; i++) hidden[i].hidden = false;
        if (grid.querySelectorAll('.dockd-review-card[data-extra="true"][hidden]').length === 0) {
          btn.style.display = 'none';
        }
      });
    });

    // Product form: "Instant Checkout" (name="checkout") is left to submit natively —
    // Shopify adds the item and redirects straight to /checkout, no JS required.
    // "Add to Cart" (name="add") is intercepted and handled via AJAX so the shopper stays on the page.
    //
    // bfcache fix: when a shopper taps the browser's back button (e.g. returning from
    // /cart or /checkout), the browser can restore this exact page from cache (bfcache)
    // instead of reloading it. If we'd left a button disabled with its text swapped to
    // "Redirecting…"/"Adding…", that stale state comes right back with it and never
    // resets — no submit/fetch handler runs again on a cache restore. So every button we
    // touch here is tracked and reset by the shared pageshow listener below.
    var dockdTrackedButtons = [];

    function dockdResetButton(btn) {
      if (!btn) return;
      btn.disabled = false;
      if (btn.dataset.originalText) {
        btn.textContent = btn.dataset.originalText;
      }
    }

    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      dockdTrackedButtons.forEach(dockdResetButton);
      document.querySelectorAll('[data-dockd-form-error]').forEach(function (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      });
    });

    document.querySelectorAll('[data-dockd-product-form]').forEach(function (form) {
      var errorEl = form.querySelector('[data-dockd-form-error]');

      function showError(message) {
        if (!errorEl) return;
        errorEl.hidden = false;
        errorEl.textContent = message;
      }

      function clearError() {
        if (!errorEl) return;
        errorEl.hidden = true;
        errorEl.textContent = '';
      }

      form.addEventListener('submit', function (e) {
        var submitter = e.submitter;
        var isCheckout = submitter && submitter.name === 'checkout';

        if (isCheckout) {
          // Native full-page submit straight to /checkout — do not intercept.
          clearError();
          if (submitter) {
            submitter.disabled = true;
            submitter.dataset.originalText = submitter.dataset.originalText || submitter.textContent;
            submitter.textContent = 'Redirecting…';
            if (dockdTrackedButtons.indexOf(submitter) === -1) dockdTrackedButtons.push(submitter);
          }
          return;
        }

        e.preventDefault();
        clearError();

        var submitBtn = submitter || form.querySelector('[name="add"]');
        var formData = new FormData(form);
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.dataset.originalText = submitBtn.dataset.originalText || submitBtn.textContent;
          submitBtn.textContent = 'Adding…';
          if (dockdTrackedButtons.indexOf(submitBtn) === -1) dockdTrackedButtons.push(submitBtn);
        }

        fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) {
                var err = new Error(data && data.description || 'Something went wrong');
                err.data = data;
                throw err;
              }
              return data;
            });
          })
          .then(function () {
            if (submitBtn) submitBtn.textContent = 'Added ✓';
            document.dispatchEvent(new CustomEvent('cart:updated'));
            var cartIcon = document.querySelector('[data-dockd-cart-count]');
            if (cartIcon) {
              fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
                cartIcon.textContent = cart.item_count;
              });
            }
            setTimeout(function () {
              if (submitBtn) {
                submitBtn.disabled = false;
                submitBtn.textContent = submitBtn.dataset.originalText;
              }
            }, 1500);
          })
          .catch(function (err) {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = submitBtn.dataset.originalText;
            }
            showError((err && err.message) || 'Something went wrong — please try again.');
          });
      });
    });
  });
})();

// Cookie consent: localStorage-based record, no cookie written and no non-essential
// script may run before the shopper has explicitly accepted. Any future non-essential
// script should gate itself behind window.dockdConsent.has('analytics') /
// window.dockdConsent.onChange(...) rather than running unconditionally.
(function () {
  'use strict';

  var CONSENT_KEY = 'dockd_cookie_consent';
  var CONSENT_VERSION = 1;

  function readConsent() {
    try {
      var raw = window.localStorage.getItem(CONSENT_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object') return null;
      return parsed;
    } catch (e) {
      return null;
    }
  }

  var currentConsent = readConsent();

  function writeConsent(analytics) {
    var record = {
      essential: true,
      analytics: !!analytics,
      version: CONSENT_VERSION,
      updatedAt: new Date().toISOString()
    };
    try {
      window.localStorage.setItem(CONSENT_KEY, JSON.stringify(record));
    } catch (e) {
      // localStorage unavailable (private mode, disabled storage, etc.) — the choice
      // still applies for the rest of this page view via the in-memory record below.
    }
    currentConsent = record;
    document.dispatchEvent(new CustomEvent('dockd:consent-updated', { detail: record }));
    return record;
  }

  // Public helper so any future non-essential script (analytics, ad pixels, etc.)
  // can check or wait for consent instead of running unconditionally.
  window.dockdConsent = {
    get: function () {
      return currentConsent;
    },
    has: function (category) {
      if (category === 'essential') return true;
      if (!currentConsent) return false;
      return !!currentConsent[category];
    },
    onChange: function (callback) {
      if (typeof callback !== 'function') return;
      document.addEventListener('dockd:consent-updated', function (e) {
        callback(e.detail);
      });
    }
  };

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var banner = document.querySelector('[data-dockd-cookie-banner]');
    var panel = document.querySelector('[data-dockd-cookie-panel]');
    var analyticsToggle = document.querySelector('[data-dockd-cookie-analytics-toggle]');
    if (!banner || !panel) return;

    function showBanner() {
      banner.hidden = false;
    }
    function hideBanner() {
      banner.hidden = true;
    }
    function openPanel() {
      if (analyticsToggle) {
        analyticsToggle.checked = currentConsent ? !!currentConsent.analytics : false;
      }
      panel.hidden = false;
    }
    function closePanel() {
      panel.hidden = true;
    }

    if (!currentConsent) {
      showBanner();
    } else {
      hideBanner();
    }

    document.querySelectorAll('[data-dockd-cookie-accept]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        writeConsent(true);
        hideBanner();
        closePanel();
      });
    });

    document.querySelectorAll('[data-dockd-cookie-reject], [data-dockd-cookie-reject-all]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        writeConsent(false);
        hideBanner();
        closePanel();
      });
    });

    document.querySelectorAll('[data-dockd-cookie-save]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        writeConsent(analyticsToggle ? analyticsToggle.checked : false);
        hideBanner();
        closePanel();
      });
    });

    document.querySelectorAll('[data-dockd-cookie-manage-open], [data-dockd-cookie-preferences]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openPanel();
      });
    });

    document.querySelectorAll('[data-dockd-cookie-panel-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        closePanel();
      });
    });

    panel.addEventListener('click', function (e) {
      if (e.target === panel) closePanel();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) closePanel();
    });
  });
})();
